import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * 电能统计-获取集中器
	 * @param {number} 集中器编号
	**/
	getStatisticsConcentrator( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/concentrator/getStatisticsConcentrator',
	    method: 'GET',
	    params
	  })
	},
	/**
	 * 电能统计-获取结果
	 * @param {lamp_id} 集中器ID
	 * @param {date} 集中器编号
	**/
	getElectricityConsumptionStatistics( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/device/concentrator/getElectricityConsumptionStatistics',
	    method: 'GET',
	    params
	  })
	}
}